<template>
    <aside>
        <ButtonCircle
                :class="{active: userAction === USER_ACTIONS.SELECT}"
                @click="setUserAction(USER_ACTIONS.SELECT)"
                title="Select"
        >
            <i class="icon-cursor"></i>
        </ButtonCircle>

        <ButtonCircle
                :class="{active: userAction === USER_ACTIONS.DRAW_LINE}"
                :disabled="trimIsCompleted || trimEditDisabled"
                @click="handleClickLine"
                title="Line"
        >
            <i class="icon-flow-line"></i>
        </ButtonCircle>

        <span class="paint">
            <PaintSwitchSideOnly :disabled="!points.length || trimEditDisabled"></PaintSwitchSideOnly>

            <!--<ButtonCircle :disabled="trimEditDisabled" @click="togglePaintMenu" title="Paint">
                <i class="icon-brush"></i>
            </ButtonCircle>

            <PaintMenu v-show="displayPaintMenu && !trimEditDisabled"
                       @close="closePaintMenu"
            ></PaintMenu>-->
        </span>

        <ButtonCircle
                :class="[
                    { active: userAction === USER_ACTIONS.SET_OPEN_HEM }
                ]"
                :disabled="disableHems"
                @click="setUserAction(USER_ACTIONS.SET_OPEN_HEM)"
                title="Open hem"
        >
            <img src="/imgs/hem-icons/open-hem.svg"/>
        </ButtonCircle>

        <ButtonCircle
                :class="[
                    { active: userAction === USER_ACTIONS.SET_CLOSE_HEM }
                ]"
                :disabled="disableHems"
                @click="setUserAction(USER_ACTIONS.SET_CLOSE_HEM)"
                title="Close hem"
        >
            <img src="/imgs/hem-icons/close-hem.svg"/>
        </ButtonCircle>

        <ButtonCircle
                :class="[
                    { active: userAction === USER_ACTIONS.SET_FOLD }
                ]"
                :disabled="disableHems"
                @click="setUserAction(USER_ACTIONS.SET_FOLD)"
                title="Fold"
        >
            <img src="/imgs/hem-icons/fold.svg"/>
        </ButtonCircle>

        <ButtonCircle :disabled="!points.length || trimEditDisabled" @click="clearTrim" title="Clear the trim" class="btn-remove">
            <i class="icon-cancel"></i>
        </ButtonCircle>
    </aside>
</template>

<script>
    import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
    // import PaintMenu from "./PaintMenu";
    import ButtonCircle from "../../components/ButtonCircle";
    import PaintSwitchSideOnly from "./PaintSwitchSideOnly";

    export default {
        name: "Sidebar",

        components: {
            PaintSwitchSideOnly,
            ButtonCircle,
            // PaintMenu
        },

        // data() {
        //     return {
        //         displayPaintMenu: false,
        //     }
        // },

        computed: {
            ...mapState('editor', [
                'points',
                'USER_ACTIONS',
                'userAction',
            ]),

            ...mapGetters('editor', [
                'disableHems',
                'trimIsCompleted',
                'trimEditDisabled',
            ]),

        },

        methods: {
            ...mapMutations('editor', [
                'setUserAction',
            ]),

            ...mapActions('editor', [
                'clearTrim',
            ]),

            handleClickLine() {
                this.setUserAction(this.USER_ACTIONS.DRAW_LINE)
            },

            togglePaintMenu() {
                this.displayPaintMenu = !this.displayPaintMenu;
            },

            closePaintMenu() {
                this.displayPaintMenu = false;
            },

        },

    }
</script>

<style scoped>
    aside {
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        flex: 1 0 auto;
        padding: 10px 12px;
        border-right: 1px solid #ccc;
        background: #f9f9f9;
    }

    .paint {
        position: relative;
    }

    button {
        margin: 0 0 10px;
    }

    .btn-remove:hover {
        color: #c60100;
    }
</style>